<template>
  <button
    id="razor-pay-subscription-web-button"
    class="btn btn-block btn-outline-primary"
    :style="(buttonActive === true)?
          'background-color: green;color: white;':
          'color: green;'"
    @click.prevent="razorPaySubscription"
				data-test="razorPayWebSubscriptionPayBtn"
  >
    Pay
  </button>
</template>

<script>
/* eslint-disable no-undef,import/first */

import { mapGetters } from 'vuex'
import tenantSpecificNames from '@/commonJs/tenantSpecificNames'
import { vendorApis } from '../../../../services/ApiServices/vendorApis'
// import * as e from 'bootstrap-vue';
import { store } from '../../../../store/store'

export default {
	name: 'razor-pay-web-integration-subscription',
	computed: {
		...mapGetters('user', ['getUserData', 'getOrderData']),
		...mapGetters('siteData', ['getPaymentId'])
	},
	data () {
		return {
			buttonActive: false,
			razorpayConfiguration: 'custo'
		}
	},
	mounted () {
		const razorPayScript = document.createElement('script')
		razorPayScript.setAttribute('src', 'https://checkout.razorpay.com/v1/checkout.js')
		document.head.appendChild(razorPayScript)
	},
	watch: {
		getPaymentId (val) {
			vendorApis.subscriptionPayment(val, this.subscriptionId)
				.then(() => {
					this.$toasted.show('Subscription Payment Completed Successfully')
					this.$router.push('/pages/vendordashboard')
				})
		}
	},
	props: {
		subscriptionId: null
	},
	methods: {
		pay () {
			const options = {
				key: tenantSpecificNames.razorPayKey, // 'rzp_live_Im4Cag6lCnir7B',
				subscription_id: this.subscriptionId, // 'sub_CCJkJ0DbN8bsMp', //
				name: 'Neo Bank',
				description: 'Subscription Payment',
				image: 'https://tst-ecommerce.s3.amazonaws.com/women-power/PROFILE_PICTURE500638559-43424fbc-7b7c-4665-b5c3-e8f1274e2dc6.png',
				handler (response) {
					store.dispatch('siteData/setPaymentIdData', response.razorpay_payment_id)
				},
				prefill: {
					name: '',
					email: ''
				},
				notes: {
					subscription_id: this.subscriptionId
				},
				theme: {
					color: '#5369f3'
				}
			}
			const rzp1 = new Razorpay(options)
			rzp1.open()
			// e.preventDefault();
		},
		razorPaySubscription () {
			this.buttonActive = true
			this.pay()
		}
	}
}
</script>
